import { render, staticRenderFns } from "./Import-Template.vue?vue&type=template&id=a04a3448"
import script from "./Import-Template.vue?vue&type=script&lang=js"
export * from "./Import-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports